import { MatchingStrategy } from "@closerplatform/spinner-openapi";
import { intl } from "../i18n/TypedIntl";
import { config } from "@fidget/common/config/config";

export const getWheelhouseDownloadUrl = (token: string, preview?: string) => {
  return `${config.services.wheelhouse.baseUrl}/resources/files/${token}` + (preview && `/${preview}` || "");
};

export const getWheelhouseDownloadToken = (url: string) => {
  const parts = url.split("/");
  return parts.length !== 0 ? parts[parts.length - 1] : undefined;
};

export const mapStrategyToString = (strategy: MatchingStrategy | string | null): string => {
  switch (strategy) {
    case MatchingStrategy.WholeDomain:
      return intl.formatMessage("settings.tagging.strategy.domain");
    case MatchingStrategy.PathRecursively:
      return intl.formatMessage("settings.tagging.strategy.pathRecursively");
    case MatchingStrategy.ExactUrl:
      return intl.formatMessage("settings.tagging.strategy.exact");
    case MatchingStrategy.PathArgs:
      return intl.formatMessage("settings.tagging.strategy.parameter");
    default:
      return "";
  }
};

export const getUrlPlaceholder = (strategy: string) => {
  switch (strategy) {
    case MatchingStrategy.WholeDomain:
      return intl.formatMessage("forExample") + " https://www.closer.app";
    case MatchingStrategy.PathRecursively:
      return intl.formatMessage("forExample") + " https://www.closer.app/offer";
    case MatchingStrategy.ExactUrl:
      return intl.formatMessage("forExample") + " https://www.closer.app/dashboard/settings/tags";
    case MatchingStrategy.PathArgs:
      return intl.formatMessage("forExample") + " utm_source=closer";
    default:
      return "";
  }
};
